import{backIn as o}from"./back.mjs.js";const t=t=>(t*=2)<1?.5*o(t):.5*(2-Math.pow(2,-10*(t-1)));export{t as anticipate};
